/**
 * Create a new FlexAppointments
 *
 * @class
 * @param {QCalViewModel} viewModel
 * @param {AppointmentHeadersWS} appointmentHeadersRequest
 * @param {AppointmentDetailWS} appointmentDetailRequest
 */
function FlexAppointments (viewModel, appointmentHeadersRequest, appointmentDetailRequest) {

  this.fetchAppointments = this.fetchAppointments.bind(this)
  this.viewModel = viewModel;
  this.appointmentHeaders = appointmentHeadersRequest;
  this.appointmentDetail = appointmentDetailRequest;
  this.isLoading = false;
  this.appointments = ko.observableArray([]);

  // Shadow AppointmentsWS
  this.doRequest = this.fetchAppointments

	/**
	 * Method curates available (visible) appointments
	 *
	 * @method activeAppointments
	 * @return {Array} Collection of AppointmentModels
	 */
  this.activeAppointments = ko.computed(function () {
    return this.appointments().reduce(function (arr, a) {
      if (['pending', 'approved', 'served_early', 'queued'].indexOf(a.status().toLowerCase()) > -1) {
        arr.push(a);
      }

      return arr;
    }, []);
  }, this);


	/**
	 * Method curates available (visible) appointments
	 *
	 * @method availableAppointments
	 * @param {Boolean} bOnlyActive
	 * @return {Array}
	 */
  this.availableAppointments = ko.computed(function () {
    if (this.viewModel && this.viewModel.selectedLocationIds().length === 0) {
      return [];
    }

    if (this.viewModel && this.viewModel.showAllAppointmentTypes() === true) {
      return this.appointments();
    }

    return this.activeAppointments();
  }, this);


	/**
	 * Method to determine how many appointments are visible in the
	 * current Calendar view
	 *
	 * @method appointmentCount
	 * @param {Boolean} bOnlyActive
	 * @return {Integer}
	 */
  this.appointmentCount = ko.pureComputed(function () {
    if (this.viewModel && this.viewModel.showAllAppointmentTypes() === true) {
      return this.activeAppointments().length;
    }

    return this.availableAppointments().length;
  }, this);

	/**
	 * Returns a structured array of appointments for the selected date.
   * Each member will have an integer representing the starting time
   * for the block of appointments along with a collection of
   * AppointmentModels that begin at that start time.
	 *
	 * @method getAppointmentStartTimes
	 * @param {Moment} startDatetime
	 * @param {Integer} iResourceId
	 * @return {Array}
	 */
  this.getAppointmentStartTimes = function (startDatetime, resourceId) {
    var returnAppointments = [];
    var timeBlockStartMapping = {};
    var dt = startDatetime.date();
    var tz = this.viewModel.timeZoneControl.selectedTZ();

    // Loop over ALL the appointments
    this.appointments().forEach(function (appt) {

      // If there is a timezone, make sure the date is adjusted to match
      if (tz) {
        // Shift the timezone
        startDatetime.tz(tz.olson[0]);
        // Reset the hour back to midnight
        startDatetime.hours(0);
        // The date can get shifted when TZs cross GMT
        // Make sure the date remains the same
        startDatetime.date(dt);

        appt.m().tz(tz.olson[0]);

      }

      var appointmentIsOnViewedDate = appt.m().isSame(startDatetime, 'day')
      var timeBlockStart = appt.timeblockStart();

      // Compare the requested date to the appointment date
      // If they match, continue to evaluate the appointment for
      // return in the collection
      if (appointmentIsOnViewedDate) {

        // If a resourceId was not passed or the passed resourceId
        // is in the AppointmentModel's
        // resourceIds collection, we can continue to evaluate this
        // appointment for return in the collection
        if (!resourceId || appt.usesResource(resourceId)) {

          if (timeBlockStartMapping.hasOwnProperty(timeBlockStart)) {
            returnAppointments[timeBlockStartMapping[timeBlockStart]].appointments.push(appt);
          } else {
            returnAppointments.push({
              'start': timeBlockStart,
              'appointments': [appt]
            });

            timeBlockStartMapping[timeBlockStart] = returnAppointments.length-1;
          }
        }
      }
    }.bind(this));

    // Return the collection of appointments inside the appointmentStartTimes
    return returnAppointments;
  }.bind(this);


	/**
   * This method looks through the found appointments and returns any on the
   * date specified.
   *
   * @method getAppointmentsByDate
   * @param {Moment} startDatetime
   * @param {Integer} [iResourceId]
   * @param {Array} [serviceTypes]
   * @return {Array}
   */
  this.getAppointmentsByDate = function (startDatetime, resourceId) {
    // Use a reduce function to find any appointments that occur on the
    // same date as the passed date and if a resource ID is passed, also
    // have that resource id
    return ret = this.appointments().reduce(function (arr, appt) {
      // If it's the same date
      if (appt.m().isSame(startDatetime, 'day')) {
        // And there is no resource ID specified ot the appointment
        // has a matching resource
        if (!resourceId || appt.resourceIds.indexOf(resourceId) > -1) {
          // add it to the collection to be returned
          arr.push(appt);
        }
      }

      return arr;
    }, []);
  };


	/**
	 * Method finds all appointments occurring on the specified date,
   * within a specified time block optionally for a specified resource
	 *
	 * @method getAppointmentsByDate
	 * @param {Moment} mDate
	 * @param {String} sTimeblock
	 * @param {Integer} [iResourceId]
	 * @return {Array}
	 */
  this.getAppointmentsByDateAndTimeblock = function (mDate, sTimeblock, iResourceId) {
    var appointments = this.getAppointmentsByDate(mDate, iResourceId);

    return appointments.reduce(function (arr, appt) {
      if (sTimeblock == appt.timeblockStart()) {
        arr.push(appt);
      }

      return arr;
    }, []);
  };


	/**
	 * Returns the shortest duration in minutes of returned appointments.
	 * This allows the interface to scale if the duration in minutes is
	 * less than 30 minutes.
	 *
	 * @method minDuration
	 * @return {Integer}
	 */
  this.minDuration = ko.computed(function () {
    return this.appointments().reduce(function (i, a) {
      return Math.min(i, a.duration);
    }, 30);
  }, this);

	/**
	 * Sets an appointment's status in the raw collection of appointments
	 *
	 * @method setAppointmentStatus
	 * @param {Integer} iAppointmentId
	 * @param {String} sStatus
	 * @return {AppointmentsWS}
	 */
  this.setAppointmentStatus = function (iAppointmentId, sStatus) {
    this.appointments().forEach(function (a) {
      if (a.id == parseInt(iAppointmentId)) {
        a.settingManualStatus = true;
        a.status(sStatus);
      }
    });

    return this;
  };

  return this;
}

FlexAppointments.prototype.fetchAppointments = function () {
  // - Only allow requests against known queues
  // - Don't run multiple requests

  // TODO: Shouldn't we warn the user if there aren't any Queues selected?
  // Part of the problem is that Queues aren't selected by default
  // BUT we DO request Appointments when the app loads
  if (
    this.viewModel.selectedQueueIds().length < 1
    || this.isLoading == true
    ) {
    return;
  }

  this.startLoading();

  this.appointmentHeaders.requestAppointments(
    this.viewModel.selectedQueueIds(),
    this.selectedDateRange(),
    this.processData.bind(this)
  )
}

/**
 *
 * @method fetchAppointment
 * @param {Number|String} appointmentId
 * @param {Function} callback
 */
FlexAppointments.prototype.fetchAppointment = function (appointmentId, callback) {
  var callbackWrapper = function () {
    callback(this.appointmentDetail.data)
  }.bind(this)

  this.appointmentDetail.requestAppointment(appointmentId, callbackWrapper)
}

/**
 * Create the date range used to query FlexAppointments from
 * the current Calendar view in the UI.
 */
FlexAppointments.prototype.selectedDateRange = function () {
    var yearMonthDay = 'YYYY-MM-DD';
    var dateRange = {}

    switch (this.viewModel.calendarViewType()) {
      case 'month':
        var today = this.viewModel.cal.today()
        dateRange.start = today.clone().subtract(1, 'month').endOf('month').format(yearMonthDay);
        dateRange.end = today.clone().endOf('month').format(yearMonthDay);
        break;
      case 'week':
        dateRange.start = this.viewModel.currentWeek().days[0].date.format(yearMonthDay);
        dateRange.end = new moment(this.viewModel.currentWeek().days[6].date).add(1,"days").format(yearMonthDay)
        break;
      case 'day':
        dateRange.start = this.viewModel.cal.today().format(yearMonthDay),
        dateRange.end = new moment(this.viewModel.cal.today()).add(1, "days").format(yearMonthDay)
        break;
    }

  var selectedTz = this.viewModel.timeZoneControl.selectedTZ();
  dateRange.timezone = (selectedTz && selectedTz.olson[0]) ? selectedTz.olson[0] : this.viewModel.timeZoneControl.userTZ;

  return dateRange;
}


/**
 * Iterates over the XML results and populates Appointments
 *
 * @method processData
 * @param text {string}  XML data as plain text
 */
FlexAppointments.prototype.processData = function() {
  var data = $.xml2json(this.appointmentHeaders.data);
  var dataAppointments = data.appointments;
  var appointments = [];
  if (dataAppointments) {
    appointments = (Array.isArray(dataAppointments) ? dataAppointments : [ dataAppointments ]).map(AppointmentModel.prototype.createFromAppointmentHeader);
  }

  this.appointments(appointments)
  this.finishLoading();
};


FlexAppointments.prototype.finishLoading = function () {
  this.isLoading = false;
  this.viewModel.setStatusMessage("FlexAppointments loaded", 1000);
}

FlexAppointments.prototype.startLoading = function () {
  this.isLoading = true;
  this.viewModel.setStatusMessage('Requesting FlexAppointments');
}

if (typeof exports !== "undefined") {
  exports.FlexAppointments = FlexAppointments;
}
